import type { ReactNode } from 'react';

export const NoticeError = ({ children }: { children: ReactNode }) => (
  <div className="tw-uppercase tw-p-6 tw-py-4 tw-bg-red-100 tw-text-red-800">{children}</div>
);
export const NoticeAlert = ({ children }: { children: ReactNode }) => (
  <div className="tw-p-6 tw-py-4 tw-bg-orange-100 tw-text-orange-400">{children}</div>
);
